import { Box, Typography } from "@mui/material";

export default function AboutHero() {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "auto", // Auto height based on content
        maxHeight: { xs: "300px", sm: "350px", md: "400px" }, // Maximum heights by screen size
        width: "100%",
        overflow: "hidden",
      }}
    >
      {/* Background Video */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
           playsInline
  preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src="/HomeBGVideo.webm" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </Box>

      {/* Content Overlay */}
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          padding: { xs: "20px", sm: "30px", md: "40px" }, // Fixed padding values
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        {/* Title Box */}
        <Box
          sx={{
            width: { xs: "95%", sm: "85%", md: "60%", lg: "40%" },
            textAlign: "center",
            py: { xs: 1, md: 1 }, // Minimal vertical padding
          }}
        >
          <Typography
            variant="h2"
            sx={{
              background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "24px", sm: "28px", md: "38px" },
              fontWeight: 700,
              mb: { xs: 1, md: 1 }, // Minimal margin
              lineHeight: 1.1,
              letterSpacing: { xs: "-0.5px", md: "-1px" },
            }}
          >
            Who We Are: Innovators in Smarter Solutions
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "white",
              fontSize: { xs: "14px", sm: "15px", md: "16px" },
              fontWeight: 400,
              mb: 0, // No bottom margin
              lineHeight: 1.2,
            }}
          >
            Empowering your operations with intelligent dashboards for real-time insights and smarter decisions.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}